export const INIT_API_VERSION = 'v2025-06-01'
